<div
	[matRippleCentered]="false"
	[matRippleDisabled]="false"
	[class.slidePanelActive]="_deviceView.layout === LayoutVariants.TABLET_PORTRAIT"
	[matRippleUnbounded]="false"
	[class.isDisabled]="disabled || (!tile && !configMode)"
	[class.inEditMode]="configMode"
	[class.hasNoLicense]="!(tile?.hasSystemPrerequisites() ?? true)"
	[class.hasNoPermission]="!configMode && !tile?.hasUserPrerequisites(_simUserService, permissionOverrule)"
	[class.configuredButNotAvailable]="!(tile?.hasAllPrerequisites(_simUserService, permissionOverrule) ?? true)"
	[class.currentTileInEditModeIndex]="tileIndex === currentTileInEditModeIndex"
	[ngClass]="{
		tile: true,
		big: size === 'big',
		medium: size === 'medium',
		small: size === 'small',
	}"
	[routerLink]="
		configMode
			? []
			: activeTrainingSessionId === null
				? [tile?.routeLink ?? '/not-found']
				: ['/simrecorder/default/', activeTrainingSessionId] //noinspection NonLocalizedPlainText
	"
	role="button"
	matRipple
>
	@if (configMode && tile) {
		<div class="configControls" appStopPropagation>
			<button mat-icon-button color="white" (click)="moveDashboardTileClicked.emit()">
				<mat-icon fontSet="fas" fontIcon="fa-exchange" style="font-size: 0.7em" inline />
			</button>
			<button mat-icon-button color="white" (click)="moveDashboardTileUpClicked.emit()" [disabled]="tileIndex === 0">
				<mat-icon fontSet="fas" fontIcon="fa-sort-size-up-alt" style="font-size: 0.7em" inline />
			</button>
			<button mat-icon-button color="white" (click)="moveDashboardTileDownClicked.emit()" [disabled]="tileIndex === tileAmount - 1">
				<mat-icon fontSet="fas" fontIcon="fa-sort-size-down" style="font-size: 0.7em" inline />
			</button>
			<button mat-icon-button color="warn" (click)="removeDashboardTile.emit()">
				<mat-icon fontSet="fas" fontIcon="fa-trash" style="font-size: 0.6em" inline />
			</button>
		</div>
	}

	@if (configMode && !tile) {
		<div class="addApplication" appStopPropagation (click)="moveDashboardTileClicked.emit()">
			<img width="40%" src="{{ baseHref }}/assets/icons/appIcons/app_addApp.svg" />
		</div>
	}

	@if (tile) {
		<div class="iconHolder">
			@if (!activeTrainingSessionId) {
				<div
					class="icon"
					[class.invertIcon]="size !== 'big'"
					[ngStyle]="{
						'background-image': tile?.icon ? 'url(' + getIconPath() + ')' : 'unset',
					}"
				></div>
			}
			@if (activeTrainingSessionId) {
				<div class="iconActiveRecording">
					<i class="fad fa-circle fa-7x warn"> </i>
				</div>
			}
		</div>
	}

	@if (size === "big") {
		<div class="textBox" [class.activeRecording]="activeTrainingSessionId">
			<div class="header">
				@if (!activeTrainingSessionId) {
					<span class="mat-h1">{{ tile?.header | translate }}</span>
				}
				@if (activeTrainingSessionId) {
					<span class="mat-h1">{{ T.APP_TILE_ACTIVE_TEAM_TRAINING_TITLE | translate }}</span>
				}
			</div>
			<div class="subHeader">
				@if (!activeTrainingSessionId) {
					<span class="mat-h3">{{ tile?.subHeader | translate }}</span>
				}
				@if (activeTrainingSessionId) {
					<span class="mat-h3">{{ T.APP_TILE_ACTIVE_TEAM_TRAINING_SUBTITLE | translate }}</span>
				}
			</div>
			<div class="headerAlt">
				<span class="mat-h2">{{ tile?.header | translate }}</span>
			</div>
			<div class="alternateHeader"></div>
		</div>
	}

	@if (size === "medium") {
		<div class="textBox">
			<div class="header">
				<span class="mat-h2">{{ tile?.header | translate }}</span>
			</div>
		</div>
	}

	@if (size === "small") {
		<div class="textBox">
			<div class="header">
				<span class="mat-h4">{{ tile?.header | translate }}</span>
			</div>
		</div>
	}
</div>
